module.exports = __webpack_public_path__ + "672b7f492b64774df2e6f6d255d6d38e.pdf";